'use strict';

import Service from "./service";


class Controller {
    constructor() {
        this.service = new Service();
    }

    initMenuController(menuController, prop, isPresenter) {
        this.service.initMenuController(menuController, prop, isPresenter);
    }

    addUserToLobby(userID, username) {
        this.service.addUserToLobby(userID, username);
    }

    removeUserFromLobby(userID) {
        this.service.removeUserFromLobby(userID);
    }
    callLobbyReminder(time) {
        this.service.callLobbyReminder(time);
    }


}

export default Controller;
